import { useSelectedNode } from "./useSelectedNode";
export var useIssueType = function useIssueType() {
  var _useSelectedNode = useSelectedNode(),
    level1Node = _useSelectedNode.level1Node,
    level2Node = _useSelectedNode.level2Node,
    level3Node = _useSelectedNode.level3Node,
    level4Node = _useSelectedNode.level4Node,
    level5Node = _useSelectedNode.level5Node;
  var issueType = "";
  var lastIssueTypeLabel = undefined;
  var nodes = [level1Node, level2Node, level3Node, level4Node, level5Node];
  for (var _i = 0, _nodes = nodes; _i < _nodes.length; _i++) {
    var node = _nodes[_i];
    if (!node) {
      break;
    }
    issueType += "".concat(node.id, "-");
    lastIssueTypeLabel = node.label;
  }
  var issueTypeWithoutEndingDash = issueType.substring(0, issueType.length - 1);
  return {
    issueType: issueTypeWithoutEndingDash,
    lastIssueTypeLabel: lastIssueTypeLabel
  };
};